import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import SlideInModalPortal from 'syf-component-library/ui/patterns/SlideInModalPortal/SlideInModalPortal';
import { Inset } from 'syf-component-library/ui/spacing';
export const ModalContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
export const ModalContainer = styled.div `
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media ${query.greaterThanMedium} {
    margin-right: 44px;
    margin-left: 44px;
  }
`;
export const ModalBody = styled.div `
  text-align: center;
`;
export const ModalImage = styled.img `
  margin-top: 18px;
  margin-bottom: 34px;
  max-width: 100%;
  max-height: 100%;
`;
export const PaymentModalWrapper = styled(Inset) `
  flex-grow: 1;
`;
export const SlideInModalPortalWrapper = styled(SlideInModalPortal) `
  svg {
    box-sizing: unset;
  }
`;
